<div dropdown class="position-relative link-dropdown mb-3 mt-3" placement="bottom">
    <a
        href
        id="basic-link"
        dropdownToggle
        (click)="(false)"
        class="basic-link-dropdown"
        aria-controls="basic-link-dropdown"
        translate
        >+ Add filter</a
    >
    <ul id="basic-link-dropdown" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="basic-link">
        <li role="menuitem">
            <button class="dropdown-item text-black" (click)="addFilter.emit('fields')" translate>Fields</button>
        </li>
        <li role="menuitem">
            <button
                class="dropdown-item text-black"
                [ngClass]="{ disabled: addedFilters.attachments }"
                (click)="addFilter.emit('attachments')"
                translate>
                Attachments
            </button>
        </li>
    </ul>
</div>
